import { USER_REQUEST, USER_ERROR, USER_SUCCESS,USER_RESTAPI } from "../actions/user";
import apiCall from "../../utils/api";
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";
import axios from "axios";

const state = { status: "", profile: {},RESTAPI: "" };

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
};

const actions = {
  [USER_REQUEST]: ({ commit, dispatch,rootGetters }) => {
    console.log("**USER_REQUEST***");
    console.log("USER _REQUEST-user");

    // get the credentials from the auth module
    console.log(rootGetters);
    console.log(rootGetters.authCredentials);
        commit(USER_REQUEST);
        var URI = state.RESTAPI + "/api/User/Login";
        const options = {
          headers: {'X-API': rootGetters.authCredentials.token}
        };
    axios
      .post(URI, {email: rootGetters.authCredentials.email, password: rootGetters.authCredentials.password },options)
      .then(resp => {
        console.log(resp);

        console.log("**USER_REQUEST-then()***");

        var profile =  { name: "doggo", title: "Monsieur" } ;
        commit(USER_SUCCESS, profile);


      })
      .catch(err => {
        console.log("**USER_REQUEST-catch()***");
        commit(USER_ERROR);
        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT);
      });

    /*
    apiCall({ url: "user/me" })
      .then(resp => {
        console.log("**USER_REQUEST-then()***");
        commit(USER_SUCCESS, resp);
      })
      .catch(() => {
        console.log("**USER_REQUEST-catch()***");
        commit(USER_ERROR);
        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT);
      });
      */
  }
};

const mutations = {
  [USER_REQUEST]: state => {
    state.status = "loading";
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = "success";
    Vue.set(state, "profile", resp);
  },
  [USER_RESTAPI]: (state, api) => {
    state.RESTAPI = api;
  },
    [USER_ERROR]: state => {
    state.status = "error";
  },
  [AUTH_LOGOUT]: state => {
    state.profile = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js